/* ============================================================
   THE PROFILE AFTER A ROUND TRIP (js/ui/desktop/door.js finish, review 2026-09-13).

   The tokens are saved — finishLogin did that — so a /me that flakes is a profile still loading, not a failed
   login: two more tries, 700 ms apart, then the room opens anyway and its boot fills the card.
   ============================================================ */
export async function retryMe(me, { tries = 3, gap = 700, wait = (ms) => new Promise((r) => setTimeout(r, ms)) } = {}) {
  let u = null;
  for (let i = 0; i < tries && !u; i++) {
    if (i) await wait(gap);
    u = await Promise.resolve()
      .then(me)
      .catch(() => null);
  }
  return u;
}
